var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailbgb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 934,
    height: 498,
    viewBox: "0 0 934 498",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M920.426 6.56842C915.727 0.579338 907.147 0.286649 900.851 4.56547L476.625 292.868C470.858 296.788 463.281 296.788 457.514 292.868L30.825 2.89178C24.561 -1.36524 16.005 -1.11038 11.417 4.91549C4.25322 14.3245 0 26.0695 0 38.8079V447.934C0 475.548 22.3858 497.934 50 497.934H883.619C911.234 497.934 933.619 475.548 933.619 447.934V44.8079C933.619 30.3798 928.691 17.1028 920.426 6.56842Z",
    fill: "#F5A1A1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailbgb);
export default __webpack_public_path__ + "static/media/emailbgb.5a25bb912f0c8a99b37916e8a5defe68.svg";
export { ForwardRef as ReactComponent };